@defer (when notifyModalOpened) {
  <sd-modal-default
    [(isOpened)]="notifyModalOpened"
    (isOpenedChange)="onModalClose($event)"
    [noPadding]="true"
    modalCustomClass="c__product-notification-modal"
    [modalTitle]="'notify.title' | translate"
    [modalTitleLevel]="4"
  >
    <div sd-modal-body>
      <p>{{ 'notify.content' | translate }}</p>

      <form [formGroup]="notifyForm">
        <fieldset>
          <div class="c__form-wrapper">
            <sd-form-input
              formControlName="email"
              [formControl]="notifyForm.controls.email"
              [labelTitle]="'notify.emailLabel' | translate"
              [placeholder]="'notify.placeholder' | translate"
              [suggestions]="suggestion"
              (inputChanged)="useDataQualityFormValidation ? loadSuggestions($event) : null"
              (blurEvent)="useDataQualityFormValidation ? validateInput() : null"
            >
              <ng-container sd-message>
                <sd-form-error
                  errorKey="pattern"
                  [errorLabel]="(useDataQualityFormValidation ? 'notify.emailError_'+notifyForm.get('email').errors?.idError:'notify.emailError' )| translate:{eMail : notifyForm.get('email').errors?.suggestedEmail}"
                  [control]="notifyForm.get('email')"
                />
                <sd-form-error
                  errorKey="required"
                  [errorLabel]="'forms.email.required' | translate"
                  [control]="notifyForm.get('email')"
                />
              </ng-container>
            </sd-form-input>
          </div>
        </fieldset>
      </form>

      <footer class="c__modal-actions" sd-modal-footer>
        <a sd-button (click)="cancelNotify()" [isSecondary]="true"> {{ 'notify.cancel' | translate }} </a>
        <button sd-button (click)="submitEmail()">
          <span>{{ 'notify.confirm' | translate }}</span>
        </button>
      </footer>
    </div>
  </sd-modal-default>
}
